import {
    type MutationExecuteStepArgs,
    type MutationOrderCancelArgs,
    type MutationPrepareArgs,
    type MutationSubmitTransactionArgs,
    type QueryOrdersArgs,
} from '@pkg/graphql/codegen/graphql';
import { cancelOrderMutation, prepareOrderMutation } from '@pkg/graphql/mutations';
import executeStepMutation from '@pkg/graphql/mutations/executeStep.graphql';
import submitTransactionMutation from '@pkg/graphql/mutations/submitTransaction.graphql';
import { orders } from '@pkg/graphql/queries';

import { type BaseParams, graphqlReturnResults, Request } from '@app/client';

// TODO: Dedupe and move to types...
type QueryProps<T> = BaseParams & { variables: T };
type MutationProps<T> = { variables: T };

// queries
async function getUserOrders(params: QueryProps<QueryOrdersArgs>) {
    return Request.graphqlQuery({
        ...params,
        query: orders,
        apiSettingsType: 'marketplace',
    });
}

// mutations
const cancelOrder = (params: MutationProps<MutationOrderCancelArgs>) => {
    return Request.graphqlMutation({
        ...params,
        query: cancelOrderMutation,
        apiSettingsType: 'marketplace',
    });
};

const prepareOrder = (params: MutationProps<MutationPrepareArgs>) => {
    return Request.graphqlMutation({
        ...params,
        query: prepareOrderMutation,
        apiSettingsType: 'marketplace',
    });
};

const executeStep = (params: MutationProps<MutationExecuteStepArgs>) => {
    return Request.graphqlMutation({
        ...params,
        query: executeStepMutation,
        apiSettingsType: 'marketplace',
    });
};
const submitTransaction = (params: MutationProps<MutationSubmitTransactionArgs>) => {
    return Request.graphqlMutation({
        ...params,
        query: submitTransactionMutation,
        apiSettingsType: 'marketplace',
    });
};

const callGetUserOrders = (params: QueryProps<QueryOrdersArgs>) => graphqlReturnResults(getUserOrders, params);
const callCancelOrder = (params: MutationProps<MutationOrderCancelArgs>) => graphqlReturnResults(cancelOrder, params);

const callPrepareOrderMutation = (params: MutationProps<MutationPrepareArgs>) =>
    graphqlReturnResults(prepareOrder, params);
const callExecuteOrderStep = (params: MutationProps<MutationExecuteStepArgs>) =>
    graphqlReturnResults(executeStep, params);
const callSubmitTransaction = (params: MutationProps<MutationSubmitTransactionArgs>) =>
    graphqlReturnResults(submitTransaction, params);

export { callCancelOrder, callGetUserOrders, callPrepareOrderMutation, callExecuteOrderStep, callSubmitTransaction };
